import api, { Notifiable } from './api';

export interface DolarResult {
    id: string;
    valor: number;
}

export const postDolar = (value: DolarResult) => api.post<DolarResult>('dolar', value);